module.exports = __webpack_public_path__ + "img/plus_white.29c1433d.svg";